export const debounce = (callback, delay) => {
  let myTimeout;
  return (...args) => {
    clearTimeout(myTimeout);
    myTimeout = setTimeout(() => {
      callback(...args);
    }, delay);
  };
};
